"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var isDisabled = ui_blocks_1.INTERACTIVE.isDisabled;
exports.Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-style: solid;\n  border-width: 0.0625rem;\n  border-color: ", ";\n\n  ", "\n"], ["\n  border-style: solid;\n  border-width: 0.0625rem;\n  border-color: ", ";\n\n  ", "\n"])), function (_a) {
  var isInverse = _a.isInverse,
      theme = _a.theme;
  return isInverse ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme) : (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.LIGHT', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isDisabled', isDisabled);
});
var templateObject_1;